import styled from 'styled-components'

export const StyledChartContainer = styled.div<{ $minHeight: string }>`
  width: 100%;
  height: ${props => props.$minHeight};
  min-height: ${props => props.$minHeight};
`

export const StyledTooltipContent = styled.div`
  background-color: ${props => props.theme.colors.white.base};
  border: 1px solid ${props => props.theme.colors.neutral.base};
  border-radius: ${props => props.theme.dimensions.borderRadius};
  padding: ${props => props.theme.spacings.small};
  box-shadow: ${props => props.theme.shadows.middle};
`

export const StyledTooltipIndicator = styled.div<{
  $color: string
  $type?: 'dot' | 'line' | 'dashed'
}>`
  width: ${props => (props.$type === 'dot' ? '8px' : '2px')};
  height: ${props => (props.$type === 'dot' ? '8px' : '12px')};
  background-color: ${props => props.$color};
  border-radius: ${props => (props.$type === 'dot' ? '50%' : '0')};
  border-style: ${props => (props.$type === 'dashed' ? 'dashed' : 'solid')};
  border-width: ${props => (props.$type === 'line' || props.$type === 'dashed' ? '1px' : '0')};
  border-color: ${props => props.$color};
  flex-shrink: 0;
`

export const StyledLegendContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacings.medium};
  justify-content: center;
  padding: ${props => props.theme.spacings.medium} 0;
`

export const StyledLegendIndicator = styled.div<{ $color: string }>`
  width: 12px;
  height: 12px;
  background-color: ${props => props.$color};
  border-radius: 2px;
  flex-shrink: 0;
`
